import React from 'react'
import PropTypes from 'prop-types'
import { Badge } from 'react-bootstrap'

import dynamic from 'next/dynamic'

import styles from './style.module.scss'
// import articleStyles from '../style.module.scss'
import noImage from '@assets/images/placeholder/article-placeholder.jpg'
import videoIcon from '@assets/images/icon/play-icon.png'
import { convertDt24h, dateCheck, getArticleImg, getImgURL } from '@shared-submodule/utils'
import { BLUR_DATA_URL_BASE64, DEFAULT_BLOG_READ } from '@shared-submodule/sm-constants'
import CustomLink from '@shared/components/customLink'
// import Calendar from '@assets/images/placeholder/calendar.svg'
import View from '@assets/images/placeholder/view.svg'

const ArticleStyles = dynamic(() => import('@shared/components/article/articleStyle'))
const MyImage = dynamic(() => import('@shared/components/myImage'))
function ArticleSearch({ data, isVideo, isFullCard }) {
  return (
    <ArticleStyles>
      {articleStyles => (
        <article
          className={`${articleStyles.article} ${styles.articleCard} ${styles.articleGrid} ${isVideo && articleStyles.video} ${
            isVideo && styles.video
          } ${isFullCard && articleStyles.fullCard} ${isFullCard && styles.fullCard} d-flex flex-column position-relative`}
          id={data?._id}>
          <CustomLink href={`/${data?.oSeo?.sSlug}` || ''} prefetch={false}>
            <a className={`${articleStyles.postimg} ${styles.postimg} d-block block-img`}>
              {isVideo && (
                <MyImage
                  src={getImgURL(data?.sThumbnailUrl) || noImage}
                  alt={data?.sTitle || 'thumbnail'}
                  blurDataURL={BLUR_DATA_URL_BASE64}
                  placeholder="blur"
                  height="80"
                  width="128"
                  layout="responsive"
                  sizes="(max-width: 767px) 120px, (max-width: 991px) 180px, (max-width: 1190px) 200px, 240px"
                />
              )}
              {!isVideo && (
                <MyImage
                  src={getArticleImg(data)?.sUrl || noImage}
                  alt={getArticleImg(data)?.sText || data?.sSrtTitle}
                  placeholder="blur"
                  blurDataURL={BLUR_DATA_URL_BASE64}
                  height="80"
                  width="128"
                  layout="responsive"
                  sizes="(max-width: 767px) 120px, (max-width: 991px) 180px, (max-width: 1190px) 200px, 240px"
                />
              )}
              {/* {isVideo && (
                <Badge bg="primary" className={`${styles.badge} ${articleStyles.badge} ${isVideo && 'video-badge'}`}>
                  {data?.category} {convertHMS(data?.nDurationSeconds)}
                </Badge>
              )} */}
            </a>
          </CustomLink>
          <div className={`${styles.postDesc} ${articleStyles.postDesc}`}>
            {data?.category &&
              !isVideo(
                <Badge bg="primary" className={`${styles.badge} ${articleStyles.badge} ${data?.isVideo && 'video-badge'} mb-2`}>
                  {data?.category}
                </Badge>
              )}
            <h1 className="small-head mb-2 h4">
              <CustomLink href={`/${data?.oSeo?.sSlug}` || ''} prefetch={false}>
                <a>{isVideo ? data?.sTitle : data?.sSrtTitle || data?.sTitle}</a>
              </CustomLink>
            </h1>
            {(data?.dPublishDisplayDate || data?.dPublishDate || data?.nDuration?.toString()) && !isFullCard && (
              <div className={`${articleStyles.articleInfo} ${styles.articleInfo} d-flex mt-auto`}>
                {(data?.dPublishDisplayDate || data?.dPublishDate) && (
                  <span className="d-flex align-items-center">
                    {/* <MyImage src={Calendar} alt="Calendar Icon" height="18" width="18" /> */}
                    <span className="ms-1">{convertDt24h(dateCheck(data?.dPublishDisplayDate || data?.dPublishDate))}</span>
                  </span>
                )}
                <span className="d-flex align-items-center">
                  <MyImage src={View} alt="View Icon" height="18" width="18" />
                  <span className="ms-1">{data?.nViewCount > -1 ? data?.nViewCount : DEFAULT_BLOG_READ}</span>
                  {/* {data?.nDuration > 0 ? data?.nDuration : DEFAULT_BLOG_READ} Min */}
                </span>
              </div>
            )}
          </div>
          {isVideo && (
            <>
              <span className={`${articleStyles.videoTime} xsmall-text font-bold d-flex align-items-center`}>
                {data?.nDuration > 0 ? data?.nDuration : DEFAULT_BLOG_READ} Min
              </span>
              <div className={`${articleStyles.videoIcon} ${styles.videoIcon} position-absolute`}>
                <MyImage src={videoIcon} alt="video" />
              </div>
            </>
          )}
        </article>
      )}
    </ArticleStyles>
  )
}
ArticleSearch.propTypes = {
  isVideo: PropTypes.bool,
  isFullCard: PropTypes.bool,
  data: PropTypes.object
}

export default ArticleSearch
